export enum StavUkolu {
	SPLNENO = 'SPLNENO',
	NESPLNENO = 'NESPLNENO',
}
